import React, { useContext } from "react";
import "./home-style.css";

import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const FAQ = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.faq : jsonDataFr.data.faq;
  return (
    <section className="faq">
      <div className="faq__inner">
        <h2 className="faq__title">FAQs</h2>

        <div className="faq__list">
          <details open className="faq__item">
            <summary>
              <span className="faq__q">{data.q1}</span>
              <span className="faq__chev" aria-hidden="true" />
            </summary>
            <p className="faq__a">{data.a1}</p>
          </details>

          <details open className="faq__item">
            <summary>
              <span className="faq__q">{data.q2}</span>
              <span className="faq__chev" aria-hidden="true" />
            </summary>
            <p className="faq__a">{data.a2}</p>
          </details>

          <details open className="faq__item">
            <summary>
              <span className="faq__q">{data.q3}</span>
              <span className="faq__chev" aria-hidden="true" />
            </summary>
            <p className="faq__a">{data.a3}</p>
          </details>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
